<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.categoryId" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name"
                       :value="item.categoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="productName" label="商品" width="100px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="productBrand" label="商品名称">
            <template slot-scope="scope">
              <div class="name">{{ scope.row.productName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="specName" label="规格" width="200px">
          </el-table-column>
          <el-table-column prop="stockNum" label="库存" width="180"></el-table-column>
          <el-table-column prop="productSytock" label="预警库存" width="180">
            <template slot-scope="scope">
              10
            </template>
          </el-table-column>
          <el-table-column prop="skuStatus" label="状态" width="200px">
            <template slot-scope="scope">
              <span :style="{color:getShowStatusTextColor(scope.row.skuStatus)}">{{
                  getShowStatusText(scope.row.skuStatus)
                }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" header-align="center" label="操作" width="140">
            <template slot-scope="scope">
              <div class="flex a-center j-center">
                <span @click="updateStoreClick(scope.row)"
                      style="cursor: pointer;color: red">
                  更新库存
                </span>
                <span @click="updateSpeStatusClick(scope.row,1)" v-if="scope.row.skuStatus === 0"
                      style="cursor: pointer;color: black" class="m-l-5">
                  下架规格
                </span>
                <span @click="updateSpeStatusClick(scope.row,0)" v-if="scope.row.skuStatus === 1"
                      style="cursor: pointer;color: green" class="m-l-5">
                  上架规格
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

    <el-dialog title="更新库存" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="30%">
      <el-form size="small" :model="form" ref="storeSetForm">
        <el-form-item label="商品名称:">
          <p>{{ form.productName }}</p>
        </el-form-item>
        <el-form-item label="商品图片:"><img :src="form.imagePath" width="120px;" v-if="form.imagePath"/>
        </el-form-item>
        <el-form-item label="库存数量"
                      label-width="80px"
                      prop="stockNum"
                      :rules="[{ required: true, message: '请输入库存数量' }]">
          <el-input type="number" v-model="form.stockNum" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="submitFunc()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js'

export default {
  name: 'storeindex',
  data () {
    return {
      /*切换菜单*/
      activeName: 'sell',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      /*搜索参数*/
      searchForm: {
        productName: '',
        categoryId: ''
      },
      /*是否显示*/
      dialogVisible: false,
      /*表单*/
      form: {
        productSkuId: 0,
        stockNum: '',
        productName: '',
        imagePath: '',
        specName: ''
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getData()
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },

    /*获取列表*/
    getData () {
      let self = this
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.type = self.activeName
      self.loading = true
      PorductApi.getProductStoreList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.productList.records
          self.categoryList = res.data.categoryList
          self.totalDataNumber = res.data.productList.total
        })
        .catch(error => {
          self.loading = false
        })
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },

    updateStoreClick (row) {
      this.form = {
        productSkuId: row.productSkuId,
        stockNum: row.stockNum || 0,
        productName: row.productName || '',
        imagePath: row.imagePath || '',
        specName: row.specName || ''
      }
      this.dialogVisible = true
    },
    updateSpeStatusClick (row, skuStatus) {
      let self = this
      let msg = ''
      if (skuStatus === 0) {
        msg = '确认要上架该规格商品吗?'
      } else if (skuStatus === 1) {
        msg = '确认要下架该规格商品吗?'
      }
      self.$confirm(msg, '提示', {
        type: 'warning'
      }).then(() => {
        PorductApi.updateProductSpeStatus({productSkuId: row.productSkuId, skuStatus}).then(res => {
          self.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getData()
        })
          .catch(error => {
            self.loading = false
          })
      })
    },
    submitFunc () {
      let self = this
      self.$refs.storeSetForm.validate(valid => {
        if (valid) {
          PorductApi.updateStoreNum(self.form, true).then(res => {
            self.$message({
              message: '修改成功',
              type: 'success'
            })
            this.getData()
            self.dialogFormVisible(true)
          })
            .catch(error => {
              self.loading = false
            })
        }
      })
    },
    /*关闭弹窗*/
    dialogFormVisible () {
      this.dialogVisible = false
    },
    getShowStatusText (skuStatus) {
      let text = ''
      if (skuStatus !== null) {
        switch (parseInt(skuStatus)) {
          case 0:
            text = '已上架'
            break
          case 1:
            text = '已下架'
            break
        }
      }
      return text
    },
    getShowStatusTextColor (skuStatus) {
      let text = ''
      if (skuStatus !== null) {
        switch (parseInt(skuStatus)) {
          case 0:
            text = '#00aa54'
            break
          case 1:
            text = 'red'
            break
        }
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/product/storeindex.vue